
import { Vue, Component, Watch } from 'vue-property-decorator';
import DefaultModal from "@/components/modal/DefaultModal.vue";

@Component({components:{ DefaultModal}})
export default class LayoutFooter extends Vue {
  // 當前router名稱
  currentRouterName = this.$route.name;

  isOpenDetail = false;
  friendlyUrl:string = null;
  ibGov:string = null;
  pdfinfo:string = null;
  fairDealing:string = null;
  privacy:string = null;
  dataPrivacy:string = null;
  legalNotice:string = null;

  /**
   * Hook
   */
  mounted() {
    this.currentRouterName = this.$route.name;
  }

  /**
   * 監聽
   */
  @Watch('$route.name')
  onRouterChanged(val) {
    this.currentRouterName = val;
  }

  toPolicyAnnouncement(){
    this.findLegalNoticeContent();
    this.isOpenDetail = true
  }

  //串API
  findFriendlyUrl(){
    // this.$InsuranceValidationApi.getSystemCodeUsingPOST({code:'LINK_FRIENDLY'})
    //   .then((res) => {
    //     this.friendlyUrl = res.data.data.value
    //     window.open(this.friendlyUrl,"_blank");
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     alert("API 錯誤");
    //   })
    //   .finally(() => {
    //     console.log(this.friendlyUrl)
    //   });
  }

  //串API
  findIbGovUrl(){
    // this.$InsuranceValidationApi.getSystemCodeUsingPOST({code:'LINK_IBGOV'})
    //   .then((res) => {
    //     this.ibGov = res.data.data.value
    //     window.open(this.ibGov,"_blank");
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     alert("API 錯誤");
    //   })
    //   .finally(() => {
    //     console.log(this.ibGov)
    //   });
  }

  findFairDealingUrl(){
    // this.$InsuranceValidationApi.getSystemCodeUsingPOST({code:'LINK_FAIR_DEALING'})
    //   .then((res) => {
    //     this.fairDealing = res.data.data.value
    //     window.open(this.fairDealing,"_blank");
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     alert("API 錯誤");
    //   })
    //   .finally(() => {
    //     console.log(this.fairDealing)
    //   });
  }

  findPrivacyUrl(){
    // this.$InsuranceValidationApi.getSystemCodeUsingPOST({code:'LINK_PRIVACY'})
    //   .then((res) => {
    //     this.privacy = res.data.data.value
    //     window.open(this.privacy,"_blank");
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     alert("API 錯誤");
    //   })
    //   .finally(() => {
    //     console.log(this.privacy)
    //   });
  }

  findDataPrivacyUrl(){
    // this.$InsuranceValidationApi.getSystemCodeUsingPOST({code:'LINK_DATA_PRIVACY'})
    //   .then((res) => {
    //     this.dataPrivacy = res.data.data.value
    //     window.open(this.dataPrivacy,"_blank");
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     alert("API 錯誤");
    //   })
    //   .finally(() => {
    //     console.log(this.dataPrivacy)
    //   });
  }

  findLegalNoticeContent(){
    // this.$InsuranceValidationApi.getSystemCodeUsingPOST({code:'POP_LETAL_NOTICE'})
    //   .then((res) => {
    //     this.legalNotice = res.data.data.value
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     alert("API 錯誤");
    //   })
    //   .finally(() => {
    //     console.log("法令公告載入完成")
    //   });
  }
}
